module.exports = __webpack_public_path__ + "static/cake_birthday-d3a53f569de5dc3c556f1350779bd2e3.jpg";